import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../utils';

const cfg = getConfig();
const CLIENT_ID = cfg.FREEAGENT_CLIENT_ID || 'MJSwt0abRcBfW6aV3BCxmA';
const CLIENT_SECRET = cfg.FREEAGENT_CLIENT_SECRET || 'LOxDJbjFoBtSSsYSFDvizw';
const CALLBACK_URL = cfg.FREEAGENT_CALLBACK_URL || 'http://localhost:3001/login';

export default function Secure() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const run = async () => {
      const authCode = localStorage.getItem('auth_code');
      if (!authCode) {
        navigate('/login');
        return;
      }

      try {
        const basicAuth = btoa(`${CLIENT_ID}:${CLIENT_SECRET}`);
        const body = new URLSearchParams();
        body.append('code', authCode);
        body.append('grant_type', 'authorization_code');
        body.append('redirect_uri', CALLBACK_URL);

        const res = await fetch('https://api.freeagent.com/v2/token_endpoint', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
            Authorization: `Basic ${basicAuth}`,
          },
          body,
        });

        const data = await res.json();

        if (data.access_token) {
          localStorage.setItem('access_token', data.access_token);
          if (data.refresh_token) {
            localStorage.setItem('refresh_token', data.refresh_token);
          }
          navigate('/');
        } else {
          setError('Failed to obtain access token');
        }
      } catch (err) {
        console.error('Token exchange failed:', err);
        setError(err.message);
      }
    };

    run();
  }, [navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="rounded-xl bg-white p-8 shadow-lg">
          <p className="text-red-600 font-medium">Authentication failed: {error}</p>
          <button
            onClick={() => navigate('/login')}
            className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-slate-900" />
        <p className="text-sm text-slate-600">Authenticating...</p>
      </div>
    </div>
  );
}
